import { render, staticRenderFns } from "./BaseDisplayWidget.vue?vue&type=template&id=ac4aa4ce&scoped=true&"
import script from "./BaseDisplayWidget.vue?vue&type=script&lang=js&"
export * from "./BaseDisplayWidget.vue?vue&type=script&lang=js&"
import style0 from "./BaseDisplayWidget.vue?vue&type=style&index=0&id=ac4aa4ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4aa4ce",
  null
  
)

export default component.exports